<!-- 直播 -->
<template>
  <div class="live-page">
    <!-- 播放器盒子 -->
    <div class="live-box">
      <player :initData="initData" v-if="initCC" :buyInfo="buyInfo" ref="player" />
      <NotStart
        ref="notStart"
        :startTime="liveInfo.startTime"
        :placeImg="liveInfo.notStartPlaceholderImg"
      />
    </div>
    <!--聊天，课程推荐，公告,广告 -->
    <div class="live-content" v-if="initCC">
      <div class="live-content-box">
        <ul class="live-content-tab">
          <li @click="changeTab(index)" v-for="(item, index) in tablist" :key="index">
            {{ cardSelected !== 0 && index === 0 ? '老师' : item }}
            <img
              v-if="index === 0"
              @click="openTabCard()"
              class="icon"
              :src="showTabCard ? UPICON : DOWNICON"
              alt=""
            />
            <span v-if="selected === index" class="border"></span>
          </li>
          <li>
            <JoinGroup v-if="buyInfo.productId" :buyInfo="{ ...buyInfo }" />
          </li>
        </ul>
        <ul class="tab-card" v-show="showTabCard">
          <li
            v-for="(item, index) in tabCardList"
            :key="index"
            :class="{ active: cardSelected === index }"
            @click="changeList(index)"
          >
            <span>{{ item }}</span>
            <img v-show="cardSelected === index" class="icon" :src="CHECKEDICON" alt="" />
          </li>
        </ul>
        <div class="tab-content">
          <Advertising :RecommendCourse="RecommendCourse" />
          <Chat
            :skuId="buyInfo.skuId"
            :isCommentGroup="isCommentGroup"
            v-show="selected === 0"
            :selected="cardSelected"
            :recommendIconShow="recommendIconShow"
            @openRecommend="recommendPopup = true"
          />
          <Announcement v-show="selected === 1" />
        </div>
      </div>
    </div>
    <commonLoading v-if="!initCC" />
    <Recommends
      :idx="-1"
      v-show="recommendPopup"
      :recommendPopup="recommendPopup"
      @closeRecommend="recommendPopup = false"
    />
    <RecommendPolling :isAlertRecommend="isAlertRecommend" />
    <OpenApp />
    <Foot />
    <!-- <AgreementPop :openCourseId="buyInfo.id"/> -->
    <EntranceTest v-if="buyInfo.id" :id="buyInfo.id" />
  </div>
</template>

<script>
import loadJS from 'load-js';
import { mapState } from 'vuex';
import moment from 'moment';
// eslint-disable-next-line import/extensions
import player from '@/pages/live/components/player';
// eslint-disable-next-line import/extensions
import commonLoading from '@/components/commonComponents/CommonLoading';
import Foot from '@/components/foot/privacy.vue';
import { reqIsBuyProduct, reqCourseDetail, reqClassNameType } from '../../api/courseDetail/index';
import { LIVE_SITE_ID } from '../../utils/common';
import Chat from './components/chat.vue';
import Announcement from './components/announcement.vue';
import Advertising from './components/advertising.vue';
import OpenApp from './components/openApp.vue';
import { liveRecommends, liveBroadcast } from '../../api/live/index';
// import AgreementPop from './components/agreementPop.vue';
import EntranceTest from './components/entranceTest.vue';
import Recommends from './components/recommends.vue';
import JoinGroup from './components/joinGroup.vue';
import RecommendPolling from './components/recommendPolling.vue';
import { gioPlatform,replaceHyphens } from '@/utils/tools';
import NotStart from './components/notStart.vue';

let flag = false;
let startViewTime = 0;

export default {
  data() {
    return {
      tablist: ['讨论区', '公告'],
      tabCardList: ['全部讨论', '仅看老师'],
      courseId: this.$route.query.courseId,
      roomId: this.$route.query.roomId,
      buyInfo: {}, // 开课信息
      initData: {},
      initCC: false, // 判断加载直播组件的时间
      RecommendCourse: {}, // 推荐数据
      DOWNICON: require('../../assets/img/live/down.png'),
      UPICON: require('../../assets/img/live/up.png'),
      CHECKEDICON: require('../../assets/img/live/checked.png'),
      selected: 0,
      cardSelected: 0,
      showTabCard: false,
      firstTab: false,
      recommendPopup: false,
      recommendIconShow: false, // 购物袋显隐
      isAlertRecommend: 0, // 是否允许轮询
      isCommentGroup: 0, // 直播间是否开启分组
      videoName: '', //视频名称
      courseName: '', //课程名称
      liveInfo:{},
    };
  },
  components: {
    player,
    Chat,
    Advertising,
    Announcement,
    commonLoading,
    OpenApp,
    Foot,
    // AgreementPop,
    EntranceTest,
    Recommends,
    JoinGroup,
    RecommendPolling,
    NotStart,
  },
  watch: {},
  computed: {
    ...mapState(['userInfo']),
  },
  beforeDestroy() {
    if (!this.$root.$data.isApp) {
      this.uploadPageWxpose();
    }
  },
  mounted() {
    if (!this.$root.$data.isApp) {
      window.addEventListener('beforeunload', this.uploadPageWxpose);
    }
    this.initCC = false;
    loadJS([
      {
        async: false,
        url: 'https://view.csslcloud.net/js/sdk/3.7.0/liveSDK.js',
      },
    ]).then(() => {
      this.getBuyInfo();
      this.courseDeatil();
    });
  },

  destroyed() {},
  methods: {
    // 初始化播放器
    async initLive() {
      const res = await liveBroadcast(this.$route.query.liveId);
      const { isCommentGroup = 0, name } = res.data;
      this.liveInfo=res.data
      this.isCommentGroup = isCommentGroup;
      this.videoName = name;
      const userid = LIVE_SITE_ID;
      // eslint-disable-next-line no-undef
      this.initData = {
        userid, // cc用户id
        roomid: this.roomId, // 直播间id
        viewercustomua: this.userInfo.id, // 用户id
        viewername: this.userInfo.nickName, // 用户名
        viewertoken: `${this.userInfo.id}:${this.buyInfo.id}`,
        pcH5Live: true,
        groupid: this.buyInfo.skuId,
      };
      flag = false;
      startViewTime = moment().unix();
      this.initCC = true;
    },
    // 查询开课信息(是否购买)
    async getBuyInfo() {
      const res = await reqIsBuyProduct(this.courseId);
      if (res?.code === 0 && res?.data?.length) {
        // 已购买
        this.buyInfo = res?.data?.[0];
        this.initLive();
        this.getCourseIds();
      } else {
        // 未购买
        this.jumpCourseDetail();
      }
    },
    uploadPageWxpose() {
      if (flag && startViewTime) return;
      flag = true;
      const endViewTime = moment().unix();
      const diff = endViewTime - startViewTime;
      startViewTime = 0;
      const { courseName, productCategoryName, price } = this;
      if (price !== null && price !== undefined) {
        gio('track', 'videoDetailexit_event', {
          courseId_var: this.buyInfo.productId.toString(),
          courseName_var: courseName,
          courseSubject_var: productCategoryName,
          coursePrice_var: price.toString(),
          isLogin_var: 'true',
          platform_var: gioPlatform(this),
          browsingDuration_var: `${diff >= 600 ? 600 : diff}`,
          isAudition_var: '否',
        });
      }
    },

    //课程详情
    async courseDeatil() {
      const res = await reqCourseDetail(this.courseId);
      if (res?.code === 0) {
        console.log(11111, res?.data);
        this.courseName = res?.data?.name;
        this.price = res?.data?.sellPrice;
        this.productCategoryName = res?.data?.productCategoryName.split('/').at(-1);
      }
      this.gioEvents(this.courseName);
    },

    // 未购买跳转到详情页
    jumpCourseDetail() {
      this.$router.push({
        path: '/courseDetail',
        query: {
          courseId: this.courseId,
        },
      });
    },
    async getCourseIds() {
      const res = await liveRecommends({ liveId: this.$route.query.liveId });
      if (res?.code === 0) {
        console.log(res?.data,222222)
        this.RecommendCourse = res?.data;
        let { couponVOList, courseVOList } = this.RecommendCourse;
        this.isAlertRecommend = this.RecommendCourse.isAlertRecommend;
        couponVOList = couponVOList ?? [];
        courseVOList = courseVOList ?? [];
        if (couponVOList.length || courseVOList.length) {
          this.recommendIconShow = true;
        }
      }
    },
    openTabCard() {
      // this.showTabCard = !this.showTabCard;
    },
    hideCard() {
      this.showTabCard = false;
    },
    changeList(index) {
      this.cardSelected = index;
      this.showTabCard = false;
    },
    changeTab(index) {
      if (this.selected === index) {
        this.showTabCard = !this.showTabCard;
        return;
      }
      this.selected = index;
      if (index > 0) {
        this.showTabCard = false;
      }
    },
    async gioEvents(name) {
      let { data } = await reqClassNameType(this.courseId);
      gio('track', 'listenCourse_event', {
        videoID_var: this.roomId,
        videoName_var: this.videoName,
        videoType_var: '直播',
        isAudition_var: '否',
        courseId_var: this.courseId.toString(),
        courseName_var: name,
        classSize_var: data.className,
        platform_var: gioPlatform(this),
        enter_var: this.$route.query?.gioEnter,
      });
    },
    checkLiveStatus(liveStatus) {
      if (liveStatus) {
        this.$refs.notStart.hide();
        return;
      }
      const {notStartPlaceholderImg,startTime}=this.liveInfo;
      const currentTime = new Date().getTime();
      if (new Date(replaceHyphens(startTime)).getTime() > currentTime) {
        console.log('直播开始时间未到');
        this.$refs.notStart.showCount();
      } else {
        console.log('已到了开始直播的时候', liveStatus);
        if (!liveStatus&&notStartPlaceholderImg) {
          this.$refs.notStart.showImg();
        }
      }
    },
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteLeave(to, from, next) {
    try {
      this.$refs.player.stopLive('stop');
    } catch (error) {
      next();
    }
    next();
  },
};
</script>
<style scoped lang="scss">
::v-deep .common-foot {
  position: fixed;
}

.live-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  padding-bottom: 100px;

  .live-box {
    position: relative;
    width: 100%;
    height: calc(100vw * 0.5625);
    overflow: hidden;
    background: black;
  }

  .live-content {
    position: relative;
    flex: 1;
    width: 100%;
    overflow: auto;

    .live-content-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      height: 100%;

      .live-content-tab {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        // padding: 40px;
        height: 120px;

        li {
          position: relative;
          width: 30%;
          color: #333;
          font-size: 32px;
          text-align: center;
          border-right: 1px solid #eee;

          .border {
            position: absolute;
            right: 0;
            bottom: -20px;
            left: 0;
            display: block;
            width: 50px;
            height: 6px;
            margin: 0 auto;
            background: #ff6c02;
            border-radius: 10px 10px 0 0;
          }
        }

        li:first-child {
          color: #ff6c02;
        }
      }
    }
  }
}

.tab-content {
  flex: 1;
  width: 100%;
  overflow: auto;
}

::v-deep .van-tabs {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
}

::v-deep .van-tab {
  // border-right: 1px solid #eee;
}

::v-deep .van-tabs__wrap {
  width: 100%;
  height: 52px;
}

::v-deep .van-tabs__content {
  flex: 1;
  width: 100%;
  overflow: auto;
}

::v-deep .van-tabs__line {
  width: 25px;
  background-color: #ff6c02;
  border-radius: 10px 10px 0 0;
}

::v-deep .van-tab__text--ellipsis {
  font-size: 15px;
}

.icon {
  position: relative;
  top: 6px;
  width: 32px;
  height: 32px;
}

.tab-card {
  position: absolute;
  top: 104px;
  left: 0;
  z-index: 200;
  width: 100%;
  height: 208px;
  background: #fff8f2;

  li {
    padding: 40px 0 0 40px;
    color: #333;
    font-size: 28px;
  }

  li.active {
    color: #ff6c02;
    font-size: 28px;
  }
}
</style>
